// Persistance éphémère des paramètres PKCE entre le départ vers le provider
// et le retour sur /auth/callback. sessionStorage : survit à la redirection,
// isolé par onglet, purgé à la fermeture.

const STORAGE_KEY = 'oidc-session';

export interface OidcSession {
  codeVerifier: string;
  state: string;
  nonce: string;
}

export function saveOidcSession(session: OidcSession): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch (e) {
    console.error('saveOidcSession error:', e);
    throw new Error('Impossible de sauvegarder la session OIDC');
  }
}

export function loadOidcSession(): OidcSession | null {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<OidcSession>;
    if (!parsed.codeVerifier || !parsed.state || !parsed.nonce) return null;
    return parsed as OidcSession;
  } catch (e) {
    console.error('loadOidcSession error:', e);
    return null;
  }
}

export function clearOidcSession(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error('clearOidcSession error:', e);
  }
}
